import React from "react";
import { CheckCircle } from "@phosphor-icons/react";

/**
 * Small "Signed by X · Yh ago" chip for completed order cards.
 * Renders nothing if the order has no signed_at timestamp — so the chip only
 * appears for orders the operator actually signed off (not orders the backend
 * auto-marked completed when all items shipped).
 */
export default function SignedChip({ order, className = "" }) {
  if (!order?.signed_at) return null;
  const when = relativeTime(order.signed_at);
  const who = (order.signed_by || "").trim();
  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.15em] font-bold rounded-md px-2 py-1 border border-emerald-300 bg-emerald-50 text-emerald-800 dark:border-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-300 ${className}`}
      data-testid={`signed-chip-${order.order_number || order.id}`}
      title={`Signed${who ? ` by ${who}` : ""} on ${new Date(order.signed_at).toLocaleString()}`}
    >
      <CheckCircle size={11} weight="fill" />
      Signed
      {who && <span className="font-semibold normal-case tracking-normal">· {who}</span>}
      {when && <span className="font-normal normal-case tracking-normal text-emerald-700/80 dark:text-emerald-300/80">· {when}</span>}
    </span>
  );
}

function relativeTime(iso) {
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return null;
  const diff = Date.now() - t;
  const min = Math.floor(diff / 60000);
  if (min < 1) return "just now";
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day}d ago`;
  return new Date(iso).toLocaleDateString();
}
